
    <div>
        <div>
            <div [ngClass]="{'justify-content-between': cardTitle, 'justify-content-end': !cardTitle}" class="flex">
                <div class="flex align-items-center justify-content-center" *ngIf="cardTitle">
                    <div>
                        <div>{{cardTitle}}</div>
                        <div *ngIf="subtitle" class="text-sm text-500 mt-1">{{subtitle}}</div>
                    </div>
                    <div *ngIf="showDateRange">
                        <i class="pi pi-info-circle ml-2" *ngIf="toolTipPath" pTooltip="{{toolTipPath | translate}}"></i>
                    </div>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <div *ngIf="!showDateRange">
                        <i class="pi pi-info-circle ml-2" *ngIf="toolTipPath" pTooltip="{{toolTipPath | translate}}"></i>
                    </div>
                    <p-dropdown *ngIf="showDateRange" [options]="dateRangeOptions" [(ngModel)]="selectedDateRange"
                    optionLabel="name" (onChange)="onDateRangeChange($event)"></p-dropdown>
                </div>
            </div>
        </div>
        <div *ngIf="chartData && chartData.length > 0; else errorBlock">
            <ng-content></ng-content>
        </div>
    </div>
    <div class="overflow-hidden">
        <div class="flex">
            <div class="flex-auto flex align-items-center justify-content-center">
                <ng-template #errorBlock>
                    <div class="card-body flex flex-column align-items-center justify-content-center p-5 mt-5">
                        <span class="pi pi-exclamation-circle text-5xl text-gray-400"></span>
                        <h5 class="text-gray-600 mb-2">{{cardTitle}}</h5>
                        <p class="text-gray-500 text-center">
                           No data available.
                        </p>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

